import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateLandingPageTemplates = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateLandingPageTemplates(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['landing-page-templates']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateLandingPageTemplates;
